<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#inbox" active>Inbox</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Inbox</h1>
    <p>A quick list for any occasions.</p>
    <hr>

    <div class="task-container">
      <div v-if="showPlaceholderImage && !hideWhenInitialLoad" class="no-task-container">
        <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
               alt="No task picture"></b-img>
        <h2>Your Inbox is empty</h2>
        <p>Congratulations, you have #NoStuffToDo!</p>
      </div>
      <regular-task-cell v-else v-for="inboxTask in inboxTaskDocuments" :key="inboxTask.taskId"
                         :task-details="inboxTask"></regular-task-cell>
    </div>
    <fab
        position="bottom-right"
        bg-color="#565A7B"
        icon-size="small"
        @click.native="openCreationModal"
    ></fab>
  </div>
</template>

<script>
  import RegularTaskCell from "../table_cells/task_cells/RegularTaskCell"
  import {mapActions, mapGetters} from "vuex"
  import {db} from "../../main"
  import fab from 'vue-fab'

  export default {
    data() {
      return {
        showPlaceholderImage: null,
        hideWhenInitialLoad: true,
        inboxTaskDocuments: []
      }
    },
    components: {
      regularTaskCell: RegularTaskCell,
      fab
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      openCreationModal() {
        this.$store.dispatch('setupCreationModal')
        this.showModal('creation-modal')
      },
      getSortedInboxTaskData(sortProperties) {
        if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('taskCreationTime', 'asc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('taskCreationTime', 'desc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('priority', 'asc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('priority', 'desc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      getFilteredInboxTaskData(filterProperties) {
        if (filterProperties.filterTypeSelected === 'None') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .orderBy('taskCreationTime', 'asc')
          ).then(() => {
            if (this.this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .where('toDoListId', '==', this.inboxToDoListId)
              .where('completed', '==', true)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .where('toDoListId', '==', this.inboxToDoListId)
              .where('completed', '==', true)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .where('toDoListId', '==', this.inboxToDoListId)
              .where('completed', '==', false)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'inboxTaskDocuments',
            db
              .collection('inbox_to_do_lists/' + this.inboxToDoListId + '/tasks')
              .where('toDoListId', '==', this.inboxToDoListId)
              .where('completed', '==', false)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.inboxTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      showModal(id) {
        this.$root.$emit('bv::show::modal', id)
      }
    },
    computed: {
      ...mapGetters([
        "inboxToDoListId",
        "sortTaskListProperties",
        "filterTaskListProperties"
      ])
    },
    watch: {
      inboxTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImage = this.inboxTaskDocuments.length === 0
      },
      sortTaskListProperties(newSortProperties, oldSortProperties) {
        this.getSortedInboxTaskData(newSortProperties)
      },
      filterTaskListProperties(newFilterProperties, oldFilterProperties) {
        this.getFilteredInboxTaskData(newFilterProperties)
      }
    },
    mounted() {
      db.collection('inbox_to_do_lists')
        .where('ownerId', '==', this.$store.getters.user.data.id)
        .get()
        .then(querySnapshot => {
          const inboxToDoListObject = querySnapshot.docs.map(doc => doc.data())
          this.$store.dispatch('setInboxToDoListId', inboxToDoListObject[0].toDoListId)
          this.$store.dispatch('setCurrentToDoListName', inboxToDoListObject[0].toDoListName)

          this.getSortedInboxTaskData({
            sortTypeSelected: 'Creation time',
            sortDirectionSelected: 'Ascending'
          })
        })
    },
    destroyed() {
      this.$store.dispatch('setCurrentToDoListName', '')
    }
  }
</script>

<style scoped>
  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .task-container {
    height: 69vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
